import React, { useEffect, useState } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
//@ts-ignore
import { FormLayout } from '@careinfo/layout';
import ConsignmentForm from './ConsignmentForm';
import moment from 'moment';
import Modal from '../Reusable/Modal';
import Button from '../Reusable/Button';
import APIS from '../../constant/EndPoint';
import { postApiData } from '../../helpers/AxiosInstance';
const EditOrder = (props: any) => {
  const {
    handleEdit,
    isLoading,
    OrderData,
    openAddReceiverPopup,
    isPrintLoading,
    setOpenAddReceiverPopup,
    handleLabelPrintDownload,
    handleConsignmentReceiptDownload,
    openAddSenderPopup,
    setOpenAddSenderPopup,
    openPrintPopup,
    setOpenPrintPopup,
  } = props;

  const {
    control,
    register,
    handleSubmit,
    getValues,
    reset,
    watch,
    setError,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: async () => {
      return {
        pickup_branch: OrderData?.pickup_branch,
        destination: OrderData?.destination,
        cod: OrderData?.cod,
        order_value: OrderData?.order_value,
        service_type: OrderData?.service_type,
        reference_date: moment().format('YYYY-MM-DD'),
        receiver_full_name: OrderData?.receiver_name,
        receiver_address: OrderData?.receiver_address,
        receiver_phone_number: OrderData?.receiver_primary_contact,
        receiver_vat_pan: OrderData?.receiver?.vat_pan,
        reference_type: OrderData?.reference_type,
        reference_number: OrderData?.reference_number,
        note: OrderData?.note,
        delivery_charge: OrderData?.delivery_charge,
        order_items: OrderData?.children?.map((item: any) => ({
          package_type: { ...item?.package_type },
          weight: item?.weight,
          piece: item?.pieces,
          remark: item?.note,
          is_rate_by_weight: item?.package_type?.is_rate_by_weight,
        })),
      };
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'order_items',
  });

  const handleClosePrintPopup = () => {
    window.location.replace('/pickup-request#/create');
    setOpenPrintPopup(false);
  };
  const [receiverId, setReceiverId] = useState<any>(null);
  const OrderItems = watch('order_items');
  const pickup = watch('pickup_branch');
  const destination = watch('destination');
  const serviceType = watch('service_type');

  useEffect(() => {
    const fetchDeliveryCharge = async () => {
      if (!OrderItems || !pickup || !serviceType || !destination) return;
      let total = 0;
      const updatedItems = [];
      for (const item of OrderItems) {
        if (!item?.package_type) return;
        const weight = Number(item?.weight) || 0;
        const piece = Number(item?.piece) || 0;
        const url = `${APIS.ORDER}delivery-charge/`;
        let formData = {
          pickup_branch: pickup?.id ?? pickup,
          service_type: serviceType?.id ?? serviceType,
          product_type: item?.package_type?.id ?? item?.package_type,
          destination: destination?.id ?? destination,
          weight: 1,
        };
        try {
          const res = await postApiData({ url, formData, setError: () => {} });
          if (res.status === 200) {
            const rate = Number(res?.data?.charge) || 0;
            total += item?.is_rate_by_weight ? weight * rate : piece * rate;
            updatedItems.push({
              ...item,
              rate: rate,
            });
          } else {
            updatedItems.push(item);
          }
        } catch (err) {
          console.error(err);
        }
      }
      setValue('delivery_charge', total);
      setValue('order_items', updatedItems);
    };

    fetchDeliveryCharge();
  }, [pickup, serviceType, destination, JSON.stringify(OrderItems)]);

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleEdit}
        setError={setError}
        disabled={!OrderData?.is_draft}
        buttonLabel={'Update'}
        isLoading={isLoading}
      >
        <ConsignmentForm
          clearErrors={clearErrors}
          errors={errors}
          register={register}
          setValue={setValue}
          getValues={getValues}
          watch={watch}
          openAddReceiverPopup={openAddReceiverPopup}
          setOpenAddReceiverPopup={setOpenAddReceiverPopup}
          openAddSenderPopup={openAddSenderPopup}
          setOpenAddSenderPopup={setOpenAddSenderPopup}
          fields={fields}
          append={append}
          remove={remove}
          setReceiverId={setReceiverId}
          control={control}
        />
      </FormLayout>
      <Modal
        isOpen={openPrintPopup}
        setIsOpen={handleClosePrintPopup}
        title={'Print '}
        children={
          <div>
            <Button
              label={'Print Label'}
              isLoading={isPrintLoading}
              disabled={isPrintLoading}
              onClick={handleLabelPrintDownload}
            />
            <Button
              label={'Print Receipt'}
              isLoading={isPrintLoading}
              disabled={isPrintLoading}
              onClick={handleConsignmentReceiptDownload}
            />
            <Button label={'Close'} onClick={handleClosePrintPopup} />
          </div>
        }
      />
    </>
  );
};

export default EditOrder;
